{
    "Profile_SupernovaCommercial_LossPayees_LossPayee.lossPayeeDetails": "Loss Payee details",
    "Profile_SupernovaCommercial_LossPayees_LossPayee.businessName": "Business Name",
    "Profile_SupernovaCommercial_LossPayees_LossPayee.withRespectTo": "With respect to (specify equipment, contents, CEF, etc.)",
    "Profile_SupernovaCommercial_LossPayees_LossPayee.addressDetails": "Address Details",
    "Profile_SupernovaCommercial_LossPayees_LossPayee.locationDetails": "Location Details"
}
